namespace OptionConst {
  export const PEOPLE_ICON_PATH = "/img/icon/people_icon.png"
  export const SYOUNIN_STATUS_WAIT_ICON_PATH = "/img/icon/syounin_status_wait_icon.png"
  export const SYOUNIN_STATUS_APPROVED_ICON_PATH = "/img/icon/syounin_status_approved_icon.png"
  export const SYOUNIN_STATUS_DENIED_ICON_PATH = "/img/icon/syounin_status_denied_icon.png"
  export const LOGO_PATH = "/img/logo.png";

  export const SEARCH_STATUS = {
    ALL: null,
    ZANGYOU: 1,
    MINE: 2,
    NEED_SYOUNIN: 3,
  }

  export const SEARCH_STATUS_OPTION = [
    { val: SEARCH_STATUS.ALL, label: 'すべての申請を表示する', hasOther: true},
    { val: SEARCH_STATUS.NEED_SYOUNIN, label: '承認が必要な申請を抽出', hasOther: false},
    // { val: SEARCH_STATUS.MINE, label: '自分が提出した申請だけ表示する', hasOther: false}, // 使っていない
    { val: SEARCH_STATUS.ZANGYOU, label: '同グループ内の時間外申請コメントを表示する', hasOther: true}
  ]
}

export default OptionConst
